import api from "@/lib/api";

export interface PutUpdatepassPaymentInformationEditRequest {
  setupIntentId: string;
  contractNumber: string;
  shouldUserInstantPayment: string;
  planPriceId: string;
  price: string;
}

export interface PutUpdatepassPaymentInformationEditResponse {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export default {
  putUpdatepassPaymentInformationEdit(data: any) {
    return api<
      PutUpdatepassPaymentInformationEditRequest,
      PutUpdatepassPaymentInformationEditResponse
    >({
      endpoint: "updatepass-payment-informations/web-api/edit",
      method: "PUT",
      body: data
    });
  }
};
